<template>
    <div>
        <!--Row 1 : AVS + No collaborateur-->
        <div class="row clearfix">
            <div class="col-md-6 column">

                <!-- Numéro AVS-->
                <div class="form-group required" :class="{'has-error': errors.has('numeroAVS')}">
                    <label for="numeroAVS" class="form-label required">{{$t('Bareme.etape1.champs.numeroAVS')}}</label>
                    <input type="tel" v-mask="'756.####.####.##'" v-model="dossier.numeroAVS" value="756"
                           class="form-control" id="numeroAVS"  v-validate="'required|validerNoAVS'" name="numeroAVS"
                           v-tooltip="{content: getTooltip('Bareme.tooltip.titre.noAVS','Bareme.tooltip.contenu.noAVS'), placement: tooltipPlacement }">
                    <span v-if="submitted && errors.has('numeroAVS')" class="text-danger">{{ errors.first('numeroAVS') }}</span>
                </div>
            </div>

            <div class="col-md-6 column">
                <!-- No de collaborateur (matricule)-->
                <div class="form-group">
                    <label for="noCollaborateur" class="form-label">{{$t('Bareme.etape1.champs.numeroCollaborateur')}}</label>
                    <input type="text" v-model="dossier.noCollaborateur" maxlength="27"
                           class="form-control" id="noCollaborateur"
                           v-tooltip="{content: getTooltip('Bareme.tooltip.titre.noCollaborateur','Bareme.tooltip.contenu.noCollaborateur'), placement: tooltipPlacement }">

                </div>
            </div>
        </div>
        <!--Row 2 : Nom + Prénom -->
        <div class="row clearfix">
            <div class="col-md-6 column">
                <!-- Nom -->
                <div class="form-group required" :class="{'has-error': errors.has('nom')}">
                    <label for="nom" class="form-label">{{$t('Bareme.etape1.champs.nom')}}</label>
                    <input type="text" v-model="dossier.nom" name="nom" v-validate="'required'" maxlength="30"
                           class="form-control" id="nom" required>
                    <span v-if="submitted && errors.has('nom')" class="text-danger">{{ errors.first('nom') }}</span>
                </div>
            </div>
            <div class="col-md-6 column">
                <!-- Prenom-->
                <div class="form-group required" :class="{'has-error': errors.has('prenom')}">
                    <label for="prenom" class="form-label">{{$t('Bareme.etape1.champs.prenom')}}</label>
                    <input type="text" v-model="dossier.prenom" name="prenom" v-validate="'required'" maxlength="30"
                           class="form-control" id="prenom" required>
                    <span v-if="submitted && errors.has('prenom')" class="text-danger">{{ errors.first('prenom') }}</span>
                </div>


            </div>
        </div>

    </div>
</template>

<script>

import TooltipUtils from '../../../utils/TooltipUtils';

export default {
  name: 'section-donnees-perso',
  // components: { SectionTooltip },
  props: ['dossier', 'submitted'],
  inject: ['$validator'],
  mixins: [TooltipUtils],
  data() {
    return {};
  },
};
</script>

<style>
</style>
